import type { IconName } from "@similarweb/icons";

import type { IUserKeywordGroup } from "app/services/keyword-groups/keywordGroups.types";
import type { ECategoryType } from "app/common/services/categoryService.types";

export interface ITableSelectionNewGroupDropdownProps {
    mode?: ETableSelectionNewGroupDropdownMode;
    groups: Array<{ id: string; text: string }>;
    onSubmit?: (name: string) => void;
    onNewListButtonClick?: () => void;
    isLoading: boolean;
    error?: boolean;
    isCreateNewListModalOpen?: boolean;
    errorMessage?: string;
    onGroupClick?: (item?: FixmeType) => void;
    onCancel?: () => void;
    count?: number;
    appendTo?: string;
    groupIconName?: IconName;
    newGroupNameLabel?: string;
    trackingCategory?: string;
    allItemsExistsMessage?: string;
    maxItemsMessage?: string;
    groupType?: "website" | "keyword" | "segment";
    selectedListType?: ECategoryType;
    hasCreateButton?: boolean;
    hasRemoveButton?: boolean;
    onRemoveKeywordsFromList?: VoidFunction;
    alertMessage?: string;
    selectedRows?: any[];
    transportKeywordListId?: (id: string) => void;
    transportStateObject?: (stateObject: { state: string; params: any }) => void;
    showSuccess?: (text: string, onClick: () => void, LinkText?: string) => void;
    showError?: (text?: string) => void;
    shouldAddNewItemToList?: boolean;
}

export interface ITableSelectionNewGroupDropdownState {
    groupName: string;
    isAutocompleteOpen: boolean;
    isKeywordRemovalModalOpen: boolean;
    isWarningOpen: boolean;
    group: IUserKeywordGroup;
    campaigns: any[];
    campaignType: ICampaignType;
    displayCampaigns: boolean;
    isLoading: boolean;
}
export enum ETableSelectionNewGroupDropdownMode {
    NEW_GROUP,
    ALL_ITEMS_EXISTS,
    MAX_ITEMS,
    GROUP_LIST,
}

export enum ICampaignType {
    RankTracker,
    BrandProtection,
}
